import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { toast } from "react-toastify";

const ChannelSettings = () => {
  document.title = "HMS | Channel Manager Settings";

  const [settings, setSettings] = useState({
    autoInventorySync: true,
    autoRateSync: true,
    autoBookingImport: true,
    autoCancellationImport: true,
    syncFrequency: "5",
    currency: "INR",
    timezone: "Asia/Kolkata",
    notificationEmail: "hotel@example.com",
    taxPercentage: "18",
    serviceCharge: "0",
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setSettings((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const saveSettings = () => {
    toast.success("Settings saved successfully");
    console.log(settings);
  };

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title="Channel Manager"
          pageTitle="Settings"
        />

        <Row>
          {/* Sync Settings */}
          <Col lg={6}>
            <Card>
              <CardHeader>
                <h4 className="card-title mb-0">
                  Sync Settings
                </h4>
              </CardHeader>

              <CardBody>
                <Form>
                  <FormGroup check className="mb-3">
                    <Input
                      type="checkbox"
                      name="autoInventorySync"
                      checked={settings.autoInventorySync}
                      onChange={handleChange}
                    />
                    <Label check>
                      Auto Inventory Sync
                    </Label>
                  </FormGroup>

                  <FormGroup check className="mb-3">
                    <Input
                      type="checkbox"
                      name="autoRateSync"
                      checked={settings.autoRateSync}
                      onChange={handleChange}
                    />
                    <Label check>
                      Auto Rate Sync
                    </Label>
                  </FormGroup>

                  <FormGroup check className="mb-3">
                    <Input
                      type="checkbox"
                      name="autoBookingImport"
                      checked={settings.autoBookingImport}
                      onChange={handleChange}
                    />
                    <Label check>
                      Auto Booking Import
                    </Label>
                  </FormGroup>

                  <FormGroup check>
                    <Input
                      type="checkbox"
                      name="autoCancellationImport"
                      checked={settings.autoCancellationImport}
                      onChange={handleChange}
                    />
                    <Label check>
                      Auto Cancellation Import
                    </Label>
                  </FormGroup>
                </Form>
              </CardBody>
            </Card>
          </Col>

          {/* Sync Frequency */}
          <Col lg={6}>
            <Card>
              <CardHeader>
                <h4 className="card-title mb-0">
                  Sync Frequency
                </h4>
              </CardHeader>

              <CardBody>
                <FormGroup>
                  <Label>
                    Inventory & Rate Sync Interval
                  </Label>

                  <Input
                    type="select"
                    name="syncFrequency"
                    value={settings.syncFrequency}
                    onChange={handleChange}
                  >
                    <option value="1">Every 1 Minute</option>
                    <option value="5">Every 5 Minutes</option>
                    <option value="10">Every 10 Minutes</option>
                    <option value="15">Every 15 Minutes</option>
                    <option value="30">Every 30 Minutes</option>
                  </Input>
                </FormGroup>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row>
          {/* Financial Settings */}
          <Col lg={6}>
            <Card>
              <CardHeader>
                <h4 className="card-title mb-0">
                  Financial Settings
                </h4>
              </CardHeader>

              <CardBody>
                <FormGroup className="mb-3">
                  <Label>Currency</Label>

                  <Input
                    type="select"
                    name="currency"
                    value={settings.currency}
                    onChange={handleChange}
                  >
                    <option>INR</option>
                    <option>USD</option>
                    <option>EUR</option>
                    <option>AED</option>
                  </Input>
                </FormGroup>

                <FormGroup className="mb-3">
                  <Label>Tax Percentage (%)</Label>

                  <Input
                    type="number"
                    name="taxPercentage"
                    value={settings.taxPercentage}
                    onChange={handleChange}
                  />
                </FormGroup>

                <FormGroup>
                  <Label>Service Charge (%)</Label>

                  <Input
                    type="number"
                    name="serviceCharge"
                    value={settings.serviceCharge}
                    onChange={handleChange}
                  />
                </FormGroup>
              </CardBody>
            </Card>
          </Col>

          {/* Notification Settings */}
          <Col lg={6}>
            <Card>
              <CardHeader>
                <h4 className="card-title mb-0">
                  Notifications
                </h4>
              </CardHeader>

              <CardBody>
                <FormGroup className="mb-3">
                  <Label>Notification Email</Label>

                  <Input
                    type="email"
                    name="notificationEmail"
                    value={settings.notificationEmail}
                    onChange={handleChange}
                  />
                </FormGroup>

                <FormGroup>
                  <Label>Timezone</Label>

                  <Input
                    type="select"
                    name="timezone"
                    value={settings.timezone}
                    onChange={handleChange}
                  >
                    <option>Asia/Kolkata</option>
                    <option>Asia/Dubai</option>
                    <option>Europe/London</option>
                    <option>America/New_York</option>
                  </Input>
                </FormGroup>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row>
          {/* Booking Rules */}
          <Col lg={12}>
            <Card>
              <CardHeader>
                <h4 className="card-title mb-0">
                  Booking Import Rules
                </h4>
              </CardHeader>

              <CardBody>
                <Row>
                  <Col md={4}>
                    <FormGroup>
                      <Label>
                        Duplicate Booking Handling
                      </Label>

                      <Input type="select">
                        <option>Ignore</option>
                        <option>Update Existing</option>
                        <option>Create New</option>
                      </Input>
                    </FormGroup>
                  </Col>

                  <Col md={4}>
                    <FormGroup>
                      <Label>
                        Missing Room Mapping
                      </Label>

                      <Input type="select">
                        <option>Reject Booking</option>
                        <option>Create Pending Booking</option>
                      </Input>
                    </FormGroup>
                  </Col>

                  <Col md={4}>
                    <FormGroup>
                      <Label>
                        Missing Rate Plan Mapping
                      </Label>

                      <Input type="select">
                        <option>Reject Booking</option>
                        <option>Use Default Rate</option>
                      </Input>
                    </FormGroup>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col lg={12}>
            <Card>
              <CardBody className="text-end">
                <Button
                  color="primary"
                  onClick={saveSettings}
                >
                  Save Settings
                </Button>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ChannelSettings;